import type { Id } from './types.ts';

/** Random, URL-safe, collision-resistant id (crypto-backed). */
export function newId(): Id {
  return globalThis.crypto.randomUUID();
}
